// @flow
import type {ClearAction, CreateAction, SetMembershipAutofillAction} from '../../../reducers/reservation';
import reconcilePersistedState from '../../../../helpers/reconcilePersistedState';
export type NameAction = {type: "SET_MEMBER_NAME", name: string};
export type EmailAction = {type: "SET_MEMBER_EMAIL", email: string};
export type PhoneAction = {type: "SET_MEMBER_PHONE", phone: string};

export type Action = NameAction | EmailAction | PhoneAction | ClearAction | CreateAction | SetMembershipAutofillAction;

type Address = {+name: string, address: string, address2: string, city: string, state: string, country: string, zip: string, phone: string, countryCode: string};

type State = { +name: string, +email: string, +phone: string, address: Address };

let initialState = {
    name: "",
    email: "",
    phone: "",
    address: false,
    infoSaved: false,
    emailOptOut: false,
    createdNewAccount: false,
    errors: {},
    id: "",
    orderCount: 0,
};

/** Reducer for member actions */
export function member(state: State = initialState, action:Action): State {
    if(action.type === "SET_MEMBER_NAME") {
        let newState = {...state};
        if(action.fromFetch) { // don't overwrite from fetch
          if(action.name == '') {
            return newState;
          }
        }
        newState.name = action.name;
        return newState;
    } else if(action.type === "SET_MEMBER_EMAIL") {
        let newState = {...state};
        if(action.fromFetch) { // don't overwrite from fetch
          if(!action.email) {
            return newState;
          }
        }
        newState.email = action.email;
        return newState;
    } else if(action.type === "SET_MEMBER_PHONE") {
        let newState = {...state};
        if(action.fromFetch) { // don't overwrite from fetch
          if(!action.phone) {
            return newState;
          }
        }
        newState.phone = action.phone;
        return newState;
    } else if(action.type === "SET_MEMBER_ADDRESS") {
        let newState = {...state};
        if(action.fromFetch) { // don't overwrite from fetch
          const hasAddressData = action.address && Object.keys(action.address)
            .some((key) => key !== 'name' && !!action.address[key]);
          if(!hasAddressData) {
            return newState;
          }
        }
        newState.address = action.address;
        return newState;
    } else if(action.type === "RESERVATION_CLEARED") {
        return initialState;
    } else if(action.type === "RESERVATION_CREATED") {
        let newState = {...state};
        if (state.address) {
          newState.address = state.address;
        }
        return newState;
    } else if(action.type === "SET_MEMBER_SAVED") {
        let newState = {...state};
        newState.infoSaved = action.value;
        return newState;
    } else if(action.type === "SET_MEMBER_EMAIL_OPT_OUT") {
        let newState = {...state};
        newState.emailOptOut = action.value;
        return newState;
    } else if(action.type === "SET_DEFAULT_MEMBER_EMAIL_OPT_OUT") {
        initialState.emailOptOut = action.value;
        return {...state};
    } else if(action.type === "SET_MEMBER_CREATED_NEW_ACCOUNT") {
        let newState = {...state};
        newState.createdNewAccount = action.value;
        return newState;
    } else if (action.type === "SET_MEMBER_FIELD_ERROR") {
        let newState = {...state};
        newState.errors = { ...state.errors };
        newState.errors[action.payload.field] = action.payload.error;
        return newState;
    } else if (action.type === 'RECONCILE_PERSISTED_STATE') {
        return reconcilePersistedState(state, initialState);
    } else if (action.type === 'RESERVATION_DATA_SET') {
      const newState = { ...state };
      const { membership_autofill, invitation_autofill } = action.reservation.attributes;

      const { firstName, lastName, email } = membership_autofill ?? {};
      if (firstName || lastName) {
        newState.name = `${firstName || ''} ${lastName || ''}`.trim();
      }
      if (email) {
        newState.email = email;
      }

      const { firstName: invFirst, lastName: invLast, email: invEmail } = invitation_autofill ?? {};
      if (invFirst || invLast) {
        newState.name = `${invFirst || ''} ${invLast || ''}`.trim();
      }
      if (invEmail) {
        newState.email = invEmail;
      }

      return newState;
    } else if (action.type === 'RESERVATION_MEMBERSHIP_AUTOFILL_SET') {
      const newState = { ...state };
      const { firstName, lastName, email } = action.membershipAutofill || {};

      if (!firstName && !lastName && !email) return newState;

      if (firstName || lastName) {
        newState.name = `${firstName || ''} ${lastName || ''}`.trim();
      }
      if (email) {
        newState.email = email;
      }

      return newState;
    } else if(action.type === "SET_MEMBER_ID") {
      const newState = {...state};
      newState.id = action.value;
      return newState;
    } else if(action.type === "SET_ORDER_COUNT") {
      const newState = {...state};
      newState.orderCount = action.value;
      return newState;
  } else {
        return state;
    }
}
